<template>
<div class="container-fluid">
    <div class="not_ib">
        <div class="text-center">
            <img src="../../assets/image/pending_ib.svg" alt="" class="pending_ib">
            <h3 class="title">Ooppsss....</h3>
            <p class="desc">You are not eligible to become an Account Manager.</p>
            <div class="option_btn">
                <router-link to="/introduction-broker/type" class="btn btn_red mb-3 mt-4">Request IB</router-link>
                <router-link to="/" class="btn btn_outline_grey">Go To Dashboard</router-link>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
.not_ib{
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.not_ib .title{
  font-weight: 700;
  color: var(--red);
}
.not_ib .option_btn .btn{
  display: block;
  width: 200px;
  margin: 0 auto;
}
</style>

<script>
export default {
  name: "DashboardNotIb",
  components: {},
  props: {
    loading : Boolean
  }
}
</script>
